import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import { BrandRequestMainContent } from '@/layouts/Brand/BrandRequestLayout/BrandRequestLayout';
import { RequestWithRelations } from '@/models/request';
import { ClientArticlesList } from '@/routes/Brand/Requests/Request/components/shared/ClientArticlesList';
import ClientStepper from '@/routes/Brand/Requests/Request/components/shared/ClientStepper';

import { StepMessage } from '../../shared/StepMessage';

const Refund = ({ request }: { request: RequestWithRelations }) => {
  const organizationName = request.organization.name;

  return (
    <BrandRequestMainContent>
      <Stack gap="1.5rem">
        <ClientStepper request={request} />

        <StepMessage
          message={
            <Paragraph size="50" color="secondary">
              <Trans id="client.request.refund.title">
                A refund will be issued by {organizationName}.
              </Trans>
            </Paragraph>
          }
        />

        <ClientArticlesList request={request} showPrice showArticleComment />
      </Stack>
    </BrandRequestMainContent>
  );
};

export default Refund;
